<script lang="ts">
	import { makeComponentClassList } from "../utils";
	import DefaultLoading from "../SVG/DefaultLoading.svelte";
	export let disabled = false;
	export let fitmode = false;
	export let defaultClassname = "";
	export let isLoading = false;
	export let background = "";
	export let nonePadding = false;
	export let id: undefined | string = undefined;
	let hovering = false;

	$: classVariables = makeComponentClassList($$props);

</script>

<button
	id={id}
	style={`background : ${background}`}
	class:nonePadding
	on:mouseenter={() => {
		hovering = true;
	}}
	on:mouseleave={() => {
		hovering = false;
	}}
	on:click
	class:fitmode
	class:isLoading
	disabled={disabled || isLoading}
	class={defaultClassname + classVariables}>
	{#if isLoading}
		<DefaultLoading inlineMode />
	{:else}
		<slot hovering={hovering} />
	{/if}
</button>

<style lang="scss">
	:global(button.isLoading:disabled svg circle) {
		stroke-width: 15;
	}

	:global(button.isLoading:disabled svg) {
		overflow: visible;
	}

	button {
		font-weight: 400;
		width: 100%;
		height: 40px;
		border-radius: 5px;
		border: none;
		background-color: var(--signature-blue);
		transition: all 0.15s;
		font-size: 1.25rem;
		&.isLoading {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		&:not(:disabled):hover {
			cursor: pointer;
		}

		&:disabled {
			background-color: var(--default-disabled-btn-1);
		}

		&.fitmode {
			height: 100%;
		}

		&:not(:disabled):hover {
			background-color: var(--default-hover-btn-1);
			box-shadow: 0 0 0 1px transparent inset, 0 0 0 0 rgba(34, 36, 38, 0.15);
		}

		&:not(:disabled):active {
			background-color: var(--default-active-btn-1);
			box-shadow: 0 0 0 1px transparent inset, 0 0 0 0 rgba(34, 36, 38, 0.15);
		}

		&.nonePadding {
			padding: 0;
		}
	}

</style>
